import { CommonEnums } from 'src/app/shared/common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Attribute } from './attribute';
import { Select_Inst } from './select_inst';

export class SelectTransform  {
    select_Inst: Select_Inst;
    attributes: Array<Attribute>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    fldr_Id: number;
    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.select_Inst = new Select_Inst();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
    }

    static parse(selectTransformTmp: SelectTransform): SelectTransform {
        let selectTransform: SelectTransform = new SelectTransform();
        selectTransform.copyFrom(selectTransformTmp);
        return selectTransform;
    }

    copy(): SelectTransform {
        let selectTransformTmp: SelectTransform = new SelectTransform();

        selectTransformTmp.select_Inst = this.select_Inst.copy();
        selectTransformTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        selectTransformTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        selectTransformTmp.ref_Id = this.ref_Id;
        selectTransformTmp.ref_Cd = this.ref_Cd;
        selectTransformTmp.fldr_Id = this.fldr_Id;
        selectTransformTmp.is_In_SubFlow = this.is_In_SubFlow;

        selectTransformTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        selectTransformTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        selectTransformTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        selectTransformTmp.change_Ind = this.change_Ind;
        selectTransformTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        selectTransformTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        selectTransformTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        selectTransformTmp.error_Cd = this.error_Cd;
        selectTransformTmp.error_Msg = this.error_Msg;

        return selectTransformTmp;
    }

    copyFrom(selectTransformTmp: SelectTransform): void {
        this.select_Inst.copyFrom(selectTransformTmp.select_Inst);

        AttributesUtil.getInstance().copyFrom(this.attributes, selectTransformTmp.attributes);

        this.nativeDbTyp_Id = selectTransformTmp.nativeDbTyp_Id;
        this.ref_Id = selectTransformTmp.ref_Id;
        this.ref_Cd = selectTransformTmp.ref_Cd;
        this.fldr_Id = selectTransformTmp.fldr_Id;
        this.is_In_SubFlow = selectTransformTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = selectTransformTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, selectTransformTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, selectTransformTmp.runPropertyTypes);

        this.change_Ind = selectTransformTmp.change_Ind;
        this.gen_Tab_Change_Ind = selectTransformTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = selectTransformTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = selectTransformTmp.rProp_Tab_Change_Ind;

        this.error_Cd = selectTransformTmp.error_Cd;
        this.error_Msg = selectTransformTmp.error_Msg;
    }

    compare(selectTransformTmp: SelectTransform): string {
        let diffString: string = this.select_Inst.compare(selectTransformTmp.select_Inst);
        if( diffString != '') return diffString;

        diffString = this.toBaseCompare(selectTransformTmp);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, selectTransformTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, selectTransformTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, selectTransformTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(selectTransformTmp: SelectTransform): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = selectTransformTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "SelectTransform [select_Inst=" + this.select_Inst.toString() + this.toBaseString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind +
                ", error_Cd=" + this.error_Cd + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
                ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
                ", error_Msg=" + this.error_Msg + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }

    toBaseString(): string {
        return ", fldr_Id=" + this.fldr_Id + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
        ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }
}